import useCountries from "@hooks/models/useCountries";
import useMainTemplate from "@templates/Main/hooks/useMainTemplate";
import ClubEditContext from "./context";
import React from 'react'
import ClubEdit from "./components/ClubEdit";
import ClubAdd from "./components/ClubAdd";
import useAuth from "@hooks/useAuth";
import { Redirect, useRouteMatch } from "react-router-dom";
import { route } from "@helpers";

export default function ClubEditPage() {
    const edit = useRouteMatch(route("club:owner:edit"))

    const { options: countries } = useCountries()
    const { user } = useAuth<Resources.Customer>()

    useMainTemplate({ category: "club" })

    if (edit && !user.club)
        return <Redirect to={route("club:customer:create")} />

    if (!edit && user.club)
        return <Redirect to={route("club:owner:edit")} />

    if (!countries)
        return null

    return (
        <ClubEditContext.Provider value={{ countries }}>
            {user.club ? <ClubEdit club={user.club} /> : <ClubAdd />}
        </ClubEditContext.Provider>
    )
}